// source: pbtypes/gen/planner/movement.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
var pbtypes_gen_planner_gimbal_orientation_mode_pb = require('../../../pbtypes/gen/planner/gimbal_orientation_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_gimbal_orientation_mode_pb);
var pbtypes_gen_planner_gimbal_roll_command_pb = require('../../../pbtypes/gen/planner/gimbal_roll_command_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_gimbal_roll_command_pb);
var pbtypes_gen_planner_movement_command_source_pb = require('../../../pbtypes/gen/planner/movement_command_source_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_movement_command_source_pb);
var pbtypes_gen_planner_spatial_waypoints_command_pb = require('../../../pbtypes/gen/planner/spatial_waypoints_command_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_spatial_waypoints_command_pb);
goog.exportSymbol('proto.planner.Movement', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.Movement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.planner.Movement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.Movement.displayName = 'proto.planner.Movement';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.Movement.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.Movement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.Movement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.Movement.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
source: jspb.Message.getFieldWithDefault(msg, 2, 0),
sourceUtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
position: (f = msg.getPosition()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
positionAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
velocity: (f = msg.getVelocity()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
velocityAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
maxSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
posVelFrame: jspb.Message.getFieldWithDefault(msg, 9, 0),
heading: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
headingSmoothness: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
headingAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
headingRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
headingRateAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
maxHeadingRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
gimbalPitch: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
gimbalPitchSmoothness: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
gimbalPitchAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
gimbalPitchRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
gimbalPitchRateAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
maxGimbalPitchRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
gimbalRollCommand: (f = msg.getGimbalRollCommand()) && pbtypes_gen_planner_gimbal_roll_command_pb.GimbalRollCommand.toObject(includeInstance, f),
enforceLookatSmoothness: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
heightAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
spatialWaypointsEnable: jspb.Message.getBooleanFieldWithDefault(msg, 26, false),
spatialWaypointsCommand: (f = msg.getSpatialWaypointsCommand()) && pbtypes_gen_planner_spatial_waypoints_command_pb.SpatialWaypointsCommand.toObject(includeInstance, f),
overridePrecisionFlight: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
gimbalOrientationMode: jspb.Message.getFieldWithDefault(msg, 29, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.Movement}
 */
proto.planner.Movement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.Movement;
  return proto.planner.Movement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.Movement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.Movement}
 */
proto.planner.Movement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.planner.MovementCommandSource.Enum} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setSourceUtime(value);
      break;
    case 4:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPositionAggressiveness(value);
      break;
    case 6:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setVelocity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setVelocityAggressiveness(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxSpeed(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPosVelFrame(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeading(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingSmoothness(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingAggressiveness(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingRate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingRateAggressiveness(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxHeadingRate(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitch(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchSmoothness(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchAggressiveness(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchRate(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchRateAggressiveness(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxGimbalPitchRate(value);
      break;
    case 22:
      var value = new pbtypes_gen_planner_gimbal_roll_command_pb.GimbalRollCommand;
      reader.readMessage(value,pbtypes_gen_planner_gimbal_roll_command_pb.GimbalRollCommand.deserializeBinaryFromReader);
      msg.setGimbalRollCommand(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnforceLookatSmoothness(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeight(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeightAggressiveness(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSpatialWaypointsEnable(value);
      break;
    case 27:
      var value = new pbtypes_gen_planner_spatial_waypoints_command_pb.SpatialWaypointsCommand;
      reader.readMessage(value,pbtypes_gen_planner_spatial_waypoints_command_pb.SpatialWaypointsCommand.deserializeBinaryFromReader);
      msg.setSpatialWaypointsCommand(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverridePrecisionFlight(value);
      break;
    case 29:
      var value = /** @type {!proto.planner.GimbalOrientationMode.Enum} */ (reader.readEnum());
      msg.setGimbalOrientationMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.Movement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.Movement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.Movement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.Movement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSourceUtime();
  if (f !== 0) {
    writer.writeSint64(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getPositionAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getVelocity();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getVelocityAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getMaxSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getPosVelFrame();
  if (f !== 0) {
    writer.writeSint32(
      9,
      f
    );
  }
  f = message.getHeading();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getHeadingSmoothness();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getHeadingAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getHeadingRate();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = message.getHeadingRateAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      14,
      f
    );
  }
  f = message.getMaxHeadingRate();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getGimbalPitch();
  if (f !== 0.0) {
    writer.writeFloat(
      16,
      f
    );
  }
  f = message.getGimbalPitchSmoothness();
  if (f !== 0.0) {
    writer.writeFloat(
      17,
      f
    );
  }
  f = message.getGimbalPitchAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = message.getGimbalPitchRate();
  if (f !== 0.0) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = message.getGimbalPitchRateAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      20,
      f
    );
  }
  f = message.getMaxGimbalPitchRate();
  if (f !== 0.0) {
    writer.writeFloat(
      21,
      f
    );
  }
  f = message.getGimbalRollCommand();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      pbtypes_gen_planner_gimbal_roll_command_pb.GimbalRollCommand.serializeBinaryToWriter
    );
  }
  f = message.getEnforceLookatSmoothness();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      24,
      f
    );
  }
  f = message.getHeightAggressiveness();
  if (f !== 0.0) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = message.getSpatialWaypointsEnable();
  if (f) {
    writer.writeBool(
      26,
      f
    );
  }
  f = message.getSpatialWaypointsCommand();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      pbtypes_gen_planner_spatial_waypoints_command_pb.SpatialWaypointsCommand.serializeBinaryToWriter
    );
  }
  f = message.getOverridePrecisionFlight();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getGimbalOrientationMode();
  if (f !== 0.0) {
    writer.writeEnum(
      29,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.planner.Movement.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MovementCommandSource.Enum source = 2;
 * @return {!proto.planner.MovementCommandSource.Enum}
 */
proto.planner.Movement.prototype.getSource = function() {
  return /** @type {!proto.planner.MovementCommandSource.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.planner.MovementCommandSource.Enum} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional sint64 source_utime = 3;
 * @return {number}
 */
proto.planner.Movement.prototype.getSourceUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setSourceUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional eigen_lcm.Vector3dPb position = 4;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.planner.Movement.prototype.getPosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 4));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.planner.Movement} returns this
*/
proto.planner.Movement.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.Movement.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float position_aggressiveness = 5;
 * @return {number}
 */
proto.planner.Movement.prototype.getPositionAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setPositionAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional eigen_lcm.Vector3dPb velocity = 6;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.planner.Movement.prototype.getVelocity = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 6));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.planner.Movement} returns this
*/
proto.planner.Movement.prototype.setVelocity = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.clearVelocity = function() {
  return this.setVelocity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.Movement.prototype.hasVelocity = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional float velocity_aggressiveness = 7;
 * @return {number}
 */
proto.planner.Movement.prototype.getVelocityAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setVelocityAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float max_speed = 8;
 * @return {number}
 */
proto.planner.Movement.prototype.getMaxSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setMaxSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional sint32 pos_vel_frame = 9;
 * @return {number}
 */
proto.planner.Movement.prototype.getPosVelFrame = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setPosVelFrame = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional float heading = 10;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional float heading_smoothness = 11;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeadingSmoothness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeadingSmoothness = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float heading_aggressiveness = 12;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeadingAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeadingAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional float heading_rate = 13;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeadingRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeadingRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional float heading_rate_aggressiveness = 14;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeadingRateAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeadingRateAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional float max_heading_rate = 15;
 * @return {number}
 */
proto.planner.Movement.prototype.getMaxHeadingRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setMaxHeadingRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional float gimbal_pitch = 16;
 * @return {number}
 */
proto.planner.Movement.prototype.getGimbalPitch = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalPitch = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional float gimbal_pitch_smoothness = 17;
 * @return {number}
 */
proto.planner.Movement.prototype.getGimbalPitchSmoothness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalPitchSmoothness = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional float gimbal_pitch_aggressiveness = 18;
 * @return {number}
 */
proto.planner.Movement.prototype.getGimbalPitchAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalPitchAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional float gimbal_pitch_rate = 19;
 * @return {number}
 */
proto.planner.Movement.prototype.getGimbalPitchRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalPitchRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional float gimbal_pitch_rate_aggressiveness = 20;
 * @return {number}
 */
proto.planner.Movement.prototype.getGimbalPitchRateAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalPitchRateAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional float max_gimbal_pitch_rate = 21;
 * @return {number}
 */
proto.planner.Movement.prototype.getMaxGimbalPitchRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setMaxGimbalPitchRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional GimbalRollCommand gimbal_roll_command = 22;
 * @return {?proto.planner.GimbalRollCommand}
 */
proto.planner.Movement.prototype.getGimbalRollCommand = function() {
  return /** @type{?proto.planner.GimbalRollCommand} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_planner_gimbal_roll_command_pb.GimbalRollCommand, 22));
};


/**
 * @param {?proto.planner.GimbalRollCommand|undefined} value
 * @return {!proto.planner.Movement} returns this
*/
proto.planner.Movement.prototype.setGimbalRollCommand = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.clearGimbalRollCommand = function() {
  return this.setGimbalRollCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.Movement.prototype.hasGimbalRollCommand = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool enforce_lookat_smoothness = 23;
 * @return {boolean}
 */
proto.planner.Movement.prototype.getEnforceLookatSmoothness = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setEnforceLookatSmoothness = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional float height = 24;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional float height_aggressiveness = 25;
 * @return {number}
 */
proto.planner.Movement.prototype.getHeightAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setHeightAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional bool spatial_waypoints_enable = 26;
 * @return {boolean}
 */
proto.planner.Movement.prototype.getSpatialWaypointsEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setSpatialWaypointsEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 26, value);
};


/**
 * optional SpatialWaypointsCommand spatial_waypoints_command = 27;
 * @return {?proto.planner.SpatialWaypointsCommand}
 */
proto.planner.Movement.prototype.getSpatialWaypointsCommand = function() {
  return /** @type{?proto.planner.SpatialWaypointsCommand} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_planner_spatial_waypoints_command_pb.SpatialWaypointsCommand, 27));
};


/**
 * @param {?proto.planner.SpatialWaypointsCommand|undefined} value
 * @return {!proto.planner.Movement} returns this
*/
proto.planner.Movement.prototype.setSpatialWaypointsCommand = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.clearSpatialWaypointsCommand = function() {
  return this.setSpatialWaypointsCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.Movement.prototype.hasSpatialWaypointsCommand = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional bool override_precision_flight = 28;
 * @return {boolean}
 */
proto.planner.Movement.prototype.getOverridePrecisionFlight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setOverridePrecisionFlight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional GimbalOrientationMode.Enum gimbal_orientation_mode = 29;
 * @return {!proto.planner.GimbalOrientationMode.Enum}
 */
proto.planner.Movement.prototype.getGimbalOrientationMode = function() {
  return /** @type {!proto.planner.GimbalOrientationMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {!proto.planner.GimbalOrientationMode.Enum} value
 * @return {!proto.planner.Movement} returns this
 */
proto.planner.Movement.prototype.setGimbalOrientationMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 29, value);
};


goog.object.extend(exports, proto.planner);
